document.addEventListener("turbo:load", function () {
  const dateRangeSelect = document.querySelector("#date_range_select");
  const startDateField  = document.querySelector("#start_date_field");

  // Only run if both elements exist
  if (dateRangeSelect && startDateField) {
    function toggleStartDateRequirement() {
      const value = dateRangeSelect.value;

      if (value === "" || value === null) {
        // No preset selected → start date required
        startDateField.required = true;
      } else {
        // Preset selected → start date not required
        startDateField.required = false;
      }
    }

    // Run once on page load
    toggleStartDateRequirement();

    // Run whenever preset changes
    dateRangeSelect.addEventListener("change", toggleStartDateRequirement);
  }
});
